import './components/apply_last_filter';
import './components/banner_between_questions';
import './components/onboarding_modal';
import './components/question_counter';
import './components/question_courses';
import './components/questions_filter_banner';
import './components/questions_filter_form';
import './components/questions_sub_filter_form';
import './components/renewal_time_box';
import './index.print.scss';
import './index.scss';
import 'components/banner/banner_damasio';
import 'components/banner/oab_questions_banner';
import 'components/banner/signup_banner';
import 'components/campaigns/interventions/leaderboard';
import 'components/contextual_nudge_card';
import 'components/empty_search_link_suggestion';
import 'components/freemium_trainer/filter_banner';
import 'components/handle_title_segment';
import 'components/modals/new_filter_modal';
import 'components/modals/not_subscribed_user_modal';
import 'components/modals/question_relevance_modal';
import 'components/modals/questions_intervention_modal';
import 'components/modals/questions_review_instructions_modal';
import 'components/modals/weekly_errors_paywall_modal';
import 'components/print_page_header';
import 'components/questions/banner';
import 'components/questions/questions_list';
import 'components/summary_suggestions';
import 'components/weekly_errors_notebook_card';
import 'styles/components/_alerts.scss';
import 'styles/components/_pagination.scss';
import 'styles/components/_print.scss';
import FreemiumLimitBottomBar from './components/freemium_limit_bottom_bar';
import { CourseSuggestionsFilter } from 'components/course_suggestions_filter';
// import ContestSurvey from 'components/svelte/contest_survey/index.svelte';
import ModalManager from 'utils/modal_manager';
// import SmartBanner from 'utils/smart_banner';
import AjaxComponentLoader from 'utils/ajax_component_loader';
import CookieManager from 'utils/cookie_manager';
import rules from 'utils/permissions/rules';

(function () {
  'use strict';

  // SmartBanner.start();

  if (
    rules.account() &&
    RAILS_ENV !== 'development' &&
    (!localStorage || localStorage.getItem('isBetaModalOpened') !== 'true')
  ) {
    ModalManager.open('#js-beta-modal');

    if (localStorage) {
      localStorage.setItem('isBetaModalOpened', 'true');
    }
  }

  // const $contestSurvey = $('.contest-survey');
  const $statisticsButtonElement = $('#filter-statistics-button');

  const { subscriptionStatus } = window.currentUser;
  const isUserStandard = subscriptionStatus === 'standard';

  const cookieKey = 'statistics_interaction';
  const hasViewedStatisticsToday = CookieManager.getCookie(cookieKey);
  const bottomBarStudySuggestion = gon.flags.study_sugestion?.active;

  if (
    isUserStandard &&
    !hasViewedStatisticsToday &&
    $statisticsButtonElement.length
  ) {
    $statisticsButtonElement.on('click', () => {
      CookieManager.setExpirationCookie(cookieKey, true, 1);
      UserTracker.emit('event', {
        eventName: 'statistics interaction',
        data: {
          context: 'questions filter'
        }
      });
    });
  }

  if (
    window.location.href.includes('institute_id') &&
    $('#course-suggestion-container').length
  ) {
    AjaxComponentLoader.load({
      component: 'course_suggestions_filter',
      type: 'component',
      data: {}
    }).then(html => {
      $('#course-suggestion-container').append(html);
      const courseSuggestionsFilter = new CourseSuggestionsFilter();
      courseSuggestionsFilter.init();
    });
  }

  // if ($contestSurvey.length) {
  //   if (window.currentUser && !localStorage.getItem('widget-survey-hide')) {
  //     const contestSurvey = new ContestSurvey({
  //       target: $contestSurvey.get(0),
  //       props: {
  //         instituteUrl: $contestSurvey.data('institute-url'),
  //         jobsUrl: $contestSurvey.data('jobs-url')
  //       }
  //     });

  //     contestSurvey.$on('close-widget', () => {
  //       contestSurvey.$destroy();
  //       localStorage.setItem('widget-survey-hide', true);
  //     });
  //   }
  // }

  if (isUserStandard && bottomBarStudySuggestion) {
    setTimeout(() => {
      AjaxComponentLoader.load({
        component: 'questions/freemium_limit_bottom_bar',
        type: 'page_component',
        data: {}
      }).then(html => {
        $('#freemium-limit-bottom-bar').append(html);
        const freemiumLimitBottomBar = new FreemiumLimitBottomBar();
        freemiumLimitBottomBar.load();
      });
    }, 2000);
  }
})(jQuery);
